module.exports = __webpack_public_path__ + "img/table.b335039d.png";